import React, { useState, useEffect } from 'react';
import { Button, DatePicker, Space, message, Typography } from 'antd';
import { generateSocialBenefitReport } from './GeneralService.js';
import BranchLocationSelector from "../BranchLocationSelector";
import { exportSocialBenefitExcel } from '../../Utils/SocialBenefitExcelExport';

const { Text } = Typography;

const ProsperityReport = ({
    loginPlaceId,
    districtData,
    districtName,
    divisionalId,
    branch
}) => {
    const [selectedDate, setSelectedDate] = useState(null);
    const [branchId, setBranchId] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (branch != null) setBranchId(branch);
    }, [branch]);

    const handleGenerate = async () => {
        if (!selectedDate) {
            message.warning("Please select a date");
            return;
        }

        setLoading(true);
        const formattedDate = selectedDate.format('YYYY-MM-DD');

        const payload = {
            selectedDate: formattedDate,
            branchId: branchId,
            isExcel: true
        };

        try {
            const response = await generateSocialBenefitReport(payload);
            const reportData = response ? Object.values(response) : [];

            if (reportData.length > 0) {
                await exportSocialBenefitExcel({
                    data: reportData,
                    date: formattedDate,
                    fileName: `Social_Benefit_Report_${formattedDate}.xlsx`,
                    loginPlaceId:loginPlaceId
                });
                message.success("Report generated successfully!");
            } else {
                message.info("No records found for the selected criteria.");
            }
        } catch (err) {
            message.error("Failed to generate report.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            padding: '40px 20px',
            backgroundColor: '#ffffff',
            minHeight: '400px'
        }}>
            <div style={{
                width: '100%',
                maxWidth: '700px',
                backgroundColor: '#d6d6cd',
                padding: '50px',
                borderRadius: '8px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.05)'
            }}>
                <Space direction="vertical" size={24} style={{ width: '100%' }}>

                   {/* Location Selectors */}
                   {loginPlaceId !== "1" && (
                       <div className="vertical-stack-fix" style={{ width: '100%' }}>
                           <style>
                               {`
                                   .vertical-stack-fix .ant-row {
                                       flex-direction: column !important;
                                   }
                                   .vertical-stack-fix .ant-col {
                                       max-width: 100% !important;
                                       width: 100% !important;
                                       text-align: left !important;
                                   }
                                   .vertical-stack-fix label {
                                       margin-bottom: 8px !important;
                                       display: flex !important;
                                   }
                               `}
                           </style>
                           <BranchLocationSelector
                               loginPlaceId={loginPlaceId}
                               districtData={districtData}
                               districtName={districtName}
                               divisionalId={divisionalId}
                               onChange={(val) => setBranchId(val?.branchId)}
                           />
                       </div>
                   )}

                    {/* Date Picker Section */}
                    <div style={{ width: '100%' }}>
                        <Text style={{ display: 'block', marginBottom: '8px', color: '#555', fontSize: '14px' }}>
                            Select Date
                        </Text>
                        <DatePicker
                            style={{
                                width: '100%',
                                height: '40px',
                                borderRadius: '4px'
                            }}
                            placeholder="Select date"
                            onChange={(date) => setSelectedDate(date)}
                        />
                    </div>

                    {/* Action Button  */}
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                        <Button
                            type="primary"
                            loading={loading}
                            disabled={!selectedDate}
                            onClick={handleGenerate}
                            style={{
                                width: '160px',
                                height: '40px',
                                backgroundColor: '#1890ff',
                                borderColor: '#bfbfbf',
                                color: '#444',
                                borderRadius: '4px',
                                fontWeight: '600'
                            }}
                        >
                            Generate Report
                        </Button>
                    </div>
                </Space>
            </div>
        </div>
    );
};

export default ProsperityReport;